/* eslint-disable */

import axios from 'axios';

//axios.defaults.baseURL = 'https://y0gky23tog.execute-api.us-east-1.amazonaws.com/dev';
axios.defaults.baseURL = process.env.VUE_APP_TEAMIO_API_URL

export default {

    namespaced: true,
    state: {
        data: [],
    },
    mutations: {

    },
    actions: {

        async getMyAccount({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                let response = await axios.post('/get-my-account', payload, { crossdomain: true });
                //console.log('Response:' + JSON.stringify(response));
                
                // Simulating async call to external service
                //await new Promise(resolve => setTimeout(resolve, 2000));
                //throw new Error("Something bad happened");
                
                dispatch('alert/setLoaded', true, {root: true});
                //dispatch('alert/setMessage', 'Workflow page created successfully!', {root: true});
                //dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
                return response;
            } catch(err) {
                console.log('Error getting my account data:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
            }
        },

        async deleteEmployee({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                let response = await axios.post('/delete-employee', payload, { crossdomain: true });
                //console.log('Response:' + JSON.stringify(response));
                
                // Simulating async call to external service
                //await new Promise(resolve => setTimeout(resolve, 2000));
                //throw new Error("Something bad happened");
                
                dispatch('alert/setLoaded', true, {root: true});
                /*
                dispatch('alert/setMessage', 'Employee deleted successfully! Please refresh this page to see the latest list', {root: true});
                dispatch('alert/setDismissSuccessCountDown', 4, {root: true});
                */
                return response;
            } catch(err) {
                dispatch('alert/setLoaded', true, {root: true});
                console.log('Error deleting employee:', err);
                throw err;
                /*
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
                */
            }
        },

        async addEmployee({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                let response = await axios.post('/add-employee', payload, { crossdomain: true });
                //console.log('Response:' + JSON.stringify(response));
                
                // Simulating async call to external service
                //await new Promise(resolve => setTimeout(resolve, 2000));
                //throw new Error("Something bad happened");
                
                dispatch('alert/setLoaded', true, {root: true});
                /*
                dispatch('alert/setMessage', 'Employee added successfully! You may need to log out and log back in to see the changes', {root: true});
                dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
                */
                return response;
            } catch(err) {
                dispatch('alert/setLoaded', true, {root: true});
                console.log('Error adding employee:', err);
                throw err;
                /*
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
                */
            }
        },

        async syncdata({commit, dispatch}, payload) {            
            try {
                dispatch('alert/setLoading', true, {root: true});                
                let response = await axios.post('/sendAction', payload, { crossdomain: true });
                //console.log(`response is ${response}`);                
                dispatch('alert/setLoaded', true, {root: true});
                dispatch('alert/setMessage', response, {root: true});
                //dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
                return response;
            } catch(err) {
                console.log('Error requesting syncdata:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
            }
        },

        async recalculateHuddleCache({commit, dispatch}, payload) {            
            try {
                dispatch('alert/setLoading', true, {root: true});                
                let response = await axios.post('/cache-huddle-data-for-site', payload, { crossdomain: true });
                console.log(`response is ${response}`);                
                dispatch('alert/setLoaded', true, {root: true});
                dispatch('alert/setMessage', 'Your huddle data is now done calculating', {root: true});
                dispatch('alert/setDismissSuccessCountDown', 5, {root: true});
                return response;
            } catch(err) {
                console.log('Error recalculating huddle cache:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
            }
        },

        async updateEmployee({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                let response = await axios.post('/update-employee', payload, { crossdomain: true });

                dispatch('alert/setLoaded', true, {root: true});
                return response;
            } catch(err) {
                dispatch('alert/setLoaded', true, {root: true});
                console.log('Error updating employee:', err);
                throw err;
            }
        },

        // Super Admin only: change a user's login email (employees.Username).
        // Attaches the caller's Firebase ID token so the backend can verify the
        // caller is a super admin (dual guard — see myaccount-service/change-login-email.js).
        async changeLoginEmail({commit, dispatch, rootState}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});

                let idToken = null;
                try {
                    const auth = rootState.getAuth();
                    if (auth && auth.currentUser) {
                        idToken = await auth.currentUser.getIdToken();
                    }
                } catch (e) {
                    console.log('changeLoginEmail: could not get ID token', e);
                }

                let response = await axios.post('/change-login-email', { ...payload, idToken }, { crossdomain: true });
                dispatch('alert/setLoaded', true, {root: true});
                return response;
            } catch(err) {
                dispatch('alert/setLoaded', true, {root: true});
                console.log('Error changing login email:', err);
                throw err;
            }
        },

        /**
         * Super Admin only: internal cost-to-Teamio for one site + month.
         *
         * This is the ONLY surface that carries `*CostToTeamioUsd`. The practice-facing usage
         * endpoints do not merely hide those columns, they never SELECT them — so cost cannot leak
         * through a forged siteID. Here the server does a real `verifyIdToken` + super-admin check
         * BEFORE it queries anything, so this action attaching a token is not decoration: without it
         * the endpoint returns 401 and no data.
         *
         * Same token pattern as changeLoginEmail above (the endpoint accepts a body `idToken` or an
         * Authorization header). Deliberately NOT routed through the wallet store: nothing
         * practice-facing should be able to reach a cost payload by importing the wrong module.
         */
        async getSiteUsageCost({ rootState }, { siteID, month = null, channel = 'sms' } = {}) {
            let idToken = null;
            try {
                const auth = rootState.getAuth();
                if (auth && auth.currentUser) {
                    idToken = await auth.currentUser.getIdToken();
                }
            } catch (e) {
                console.log('getSiteUsageCost: could not get ID token', e);
            }

            const response = await axios.post(
                '/get-site-usage-cost',
                { siteID, month, channel, idToken },
                { crossdomain: true }
            );
            return response && response.data;
        },

    }
}